import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CarryOnIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CarryOnGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.2771 20.5986H4.90359C3.35225 20.5986 2.09009 19.3365 2.09009 17.7851V9.60878C2.09009 8.05853 3.35225 6.79637 4.90359 6.79637H19.2771C20.8285 6.79637 22.0901 8.05853 22.0901 9.60878V17.7851C22.0901 19.3365 20.8285 20.5986 19.2771 20.5986ZM4.90359 7.9096C3.96593 7.9096 3.20331 8.67168 3.20331 9.6088V17.7851C3.20331 18.7222 3.96594 19.4854 4.90359 19.4854H19.2771C20.2142 19.4854 20.9769 18.7222 20.9769 17.7851V9.6088C20.9769 8.67168 20.2142 7.9096 19.2771 7.9096H4.90359Z"
        fill={fill}
      />
      <path
        d="M15.576 20.5986H8.60419C8.29653 20.5986 8.04758 20.3497 8.04758 20.042V5.0874C8.04758 4.1579 8.80368 3.40234 9.73263 3.40234H14.4481C15.377 3.40234 16.1326 4.1579 16.1326 5.0874V20.042C16.1326 20.3497 15.8836 20.5986 15.576 20.5986ZM9.1608 19.4854H15.0194V5.0874C15.0194 4.77213 14.7634 4.51557 14.4481 4.51557H9.73264C9.41738 4.51557 9.16081 4.77213 9.16081 5.0874L9.1608 19.4854Z"
        fill={fill}
      />
    </svg>
  );
};

export default CarryOnIcon;
